import React from 'react'
import { Flow, FlowName, FlowScreenElement } from '../../../../../@types/flow-types'
import { MultimediaUploaderType } from '../../../../../@types/multimedia-types'
import { RealEstateCategory, RealEstateFeatures, SegmentationType, TransactionType } from '../../../../../@types/types'
import Address from '../../../../../components/pages/insertionPage/screens/address/Address'
import Connections from '../../../../../components/pages/insertionPage/screens/connections/Connections'
import ContactInfo from '../../../../../components/pages/insertionPage/screens/contactInfo/ContactInfo'
import CommercialCostsRent from '../../../../../components/pages/insertionPage/screens/costs/wrappers/commercial/CommercialCostsRent'
import Description from '../../../../../components/pages/insertionPage/screens/description/Description'
import Multimedia from '../../../../../components/pages/insertionPage/screens/multimediaNew/Multimedia'

import OtherFacilities from '../../../../../components/pages/insertionPage/screens/otherFacilities/OtherFacilities'
import {
  estateFeatures,
  flooringType,
  floorLoadField,
  frontWindowLength,
  goodsLift,
  interiorQuality,
  locationClassificationType,
  parkingSpace,
  supplyType,
  totalFloorsField,
} from '../../../../../components/pages/insertionPage/screens/otherFacilities/wrapper/otherFacilitiesFieldsWrapper'
import {
  SCREEN_ADDRESS,
  SCREEN_CONNECTIONS,
  SCREEN_CONTACT_INFO,
  SCREEN_COSTS,
  SCREEN_DESCRIPTION,
  SCREEN_MULTIMEDIA,
  SCREEN_OTHER_FACILITIES,
  SCREENS,
} from '../../../../../services/domain/wizardScreens'
import { TENANT_STORE_RENT_FLOW_PATH } from '../../../../../services/routes/routes'
import { getDefaultClasses } from '../../../../../utils/style-utils'
import { storeRentBasicInfoScreen } from '../../propertyOwner/store/propertyOwnerStoreRentFlow'
import { tenantStoreRentSchema } from './tenantStoreRentSchema'

const tenantStoreRentFlowScreens: FlowScreenElement[] = [
  {
    screen: SCREENS[SCREEN_ADDRESS],
    element: (props) => <Address {...props} />,
  },
  storeRentBasicInfoScreen,
  {
    screen: SCREENS[SCREEN_COSTS],
    element: (props) => (
      <CommercialCostsRent {...props} hasMoveInDate={true} screenTooltip='tooltip.screens.costs.allRent' />
    ),
  },
  {
    screen: SCREENS[SCREEN_DESCRIPTION],
    element: (props) => <Description {...props} hasLocationNote={true} />,
  },
  {
    screen: SCREENS[SCREEN_MULTIMEDIA],
    element: (props) => (
      <Multimedia
        {...props}
        doCloseMultimediaStatusMessage={props.doCloseMultimediaStatusMessage!}
        allowedTypesToDisplay={[MultimediaUploaderType.PICTURE, MultimediaUploaderType.VIDEO]}
      />
    ),
  },
  {
    screen: SCREENS[SCREEN_OTHER_FACILITIES],
    element: (props) => (
      <OtherFacilities
        {...props}
        screenTooltipKey='tooltip.screens.otherFacilities.allRent'
        properties={[
          estateFeatures([
            RealEstateFeatures.BASEMENT,
            RealEstateFeatures.RAMP,
            RealEstateFeatures.LISTED,
            RealEstateFeatures.ELEVATOR,
          ]),
          interiorQuality(),
          locationClassificationType(getDefaultClasses('left')),
          frontWindowLength(getDefaultClasses('right')),
          supplyType(),
          flooringType(),
          floorLoadField(getDefaultClasses('left'), 'floorLoadCeiling'),
          totalFloorsField(getDefaultClasses('right')),
          goodsLift(),
          parkingSpace({ showParkingSpaceType: false }),
        ]}
      />
    ),
  },
  {
    screen: SCREENS[SCREEN_CONNECTIONS],
    element: (props) => <Connections {...props} />,
  },
  {
    screen: SCREENS[SCREEN_CONTACT_INFO],
    element: (props) => <ContactInfo {...props} />,
  },
]

export const tenantStoreRentFlow: Flow = {
  flowInformation: {
    owner: 'wizard.navigation.header.tenant',
    estateType: 'wizard.navigation.header.store',
    path: TENANT_STORE_RENT_FLOW_PATH,
    name: FlowName.TENANT_STORE_RENT,
    validationSchema: tenantStoreRentSchema,
    options: {
      hasTextSuggestions: true,
    },
    metaData: {
      category: RealEstateCategory.STORE,
      segmentation: SegmentationType.TENANT,
      transaction: TransactionType.RENT,
    },
  },
  defaultStateValues: { hideStreetAndStreetNumber: false },
  flowScreens: tenantStoreRentFlowScreens,
}
